import React, { useContext, useState, useEffect, useRef } from "react";
import MyContext from "../../../MyContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "../../../App.css";
import CreateBanner from "./CreateBanner";
import { useNavigate, useLocation } from "react-router-dom";
import HtmlEditor from "./HtmlEditorComponents/HtmlEditor";
import { FaEye } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { SlArrowRight } from "react-icons/sl";
import { SlArrowLeft } from "react-icons/sl";
import './Banner.css';
import BannerLibrary from "./BannerLibrary";

function Banner({ userID }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { baseUrl, config, generatedHTML, setGeneratedHTML } =
    useContext(MyContext);
  const [fetchedBanner, setFetchedBanner] = useState([]);
const [previewHTML,setPreviewHTML] = useState("");
const [showModal,setShowModal] = useState(false);

  const scrollRef = useRef(null);
const openPreview = (html)=>{
  setPreviewHTML(html);
  setShowModal(true);
};

const closePreview = ()=>{
  setShowModal(false);
  setPreviewHTML("");
};
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  const fetchBanner = async () => {
    try {
      const res = await axios.post(
        `${baseUrl}/api/Inventory/v2.0/getCardLayoutGrocery`,
        { userid: "A1211", status: "A" },
        config,
      );
      const { responseCode, responseMessage } = res.data || {};
      if (responseCode === "00") {
        setFetchedBanner(res.data.response || []);
      } else {
        toast.error(responseMessage || "Failed");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  const updateBannerStatus = async (userid, cardid, status) => {
    try {
      const res = await axios.post(
        `${baseUrl}/api/Inventory/v2.0/updateCardLayoutGroceryStatus`,
        { userid, cardid, status },
        config,
      );
      const { responseCode, responseMessage } = res.data || {};
      if (responseCode === "00") {
        toast.success(responseMessage || "Status updated successfully");
        fetchBanner();
      } else {
        toast.error(responseMessage || "Failed to update status");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  useEffect(() => {
    if (location.pathname === "/Inventory/Banner/") {
      fetchBanner();
    }
  }, [location.pathname]);

  return (
    <div
      className="d-flex flex-column justify-content-start align-items-start mx-4"
      style={{ padding: "28px 0", height: "100vh", overflow: "hidden"}}
    >
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <div className=" w-100 col-12 d-flex gap-0 flex-column m-0 align-items-start ">

        {/* Page header */}
        <div className="d-flex justify-content-between mb-1">
          <div className="d-flex flex-column">
            <h2 className="CreateCampaign">Banner Management</h2>
            <p>
              Create reusable banner templates that save time and ensure
              consistency
            </p>
          </div>
        </div>

        {/* TABS */}
        <div className="d-flex gap-3 mb-0 border-bottom pb-0 col-md-12 col-12">
          <button
            className="btn border-none fw-normal"
            style={{
              borderBottom:
                location.pathname === "/Inventory/Banner"
                  ? "3px solid #00c47d"
                  : "3px solid transparent",
              color:
                location.pathname === "/Inventory/Banner" ? "#00c47d" : "black",
              borderRadius: "0px",
            }}
            onClick={() => navigate("/Inventory/Banner")}
          >
            Banner Library
          </button>

          <button
            className="btn border-none fw-normal"
            style={{
              borderBottom:
                location.pathname === "/Inventory/Banner/create-new-banner"
                  ? "3px solid #00c47d"
                  : "3px solid transparent",
              color:
                location.pathname === "/Inventory/Banner/create-new-banner"
                  ? "#00c47d"
                  : "black",
              borderRadius: "0px",
            }}
            onClick={() => {
              setGeneratedHTML("");
              navigate("/Inventory/Banner/create-new-banner");
            }}
          >
            Create Banner
          </button>
          
        </div>

        {/* TAB CONTENT */}
        <div className="mt-0 " style={{ width: "100%" }}>

          {/* Banner Library */}
          {location.pathname === "/Inventory/Banner" && (
            <div style={{  height: "100%" }}>
              <BannerLibrary fetchedBanner={fetchedBanner} setFetchedBanner={setFetchedBanner} setPreviewHTML={setPreviewHTML} setShowModal={setShowModal} openPreview={openPreview} closePreview={closePreview} />
            </div>
          )}
          {/* ── Create Banner ── */}
          {location.pathname === "/Inventory/Banner/create-new-banner" && (
            <div style={{ width: "55vw", height: "100%" }}>
              <CreateBanner />
            </div>
          )}

          {/* ── HTML Editor ── */}
          {location.pathname === "/Inventory/Banner/html-editor" && (
            <HtmlEditor />
          )}
        </div>
      </div>
      {showModal && (
  <div className="banner-preview-modal">

    <div className="banner-preview-content">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Banner Preview</h5>

        <button 
          className="btn btn-sm btn-light"
          onClick={closePreview}
        >
          ✕
        </button>
      </div>

      <div
        className="hide-scrollbar overflow-scroll d-flex"
        style={{
          backgroundColor:"#ebebeb",
          height:"70vh",
          borderRadius:"8px",
          padding:"10px"
        }}
        dangerouslySetInnerHTML={{__html:previewHTML}}
      />

    </div>

  </div>
)}
    </div>
  );
}

export default Banner;
